import React from 'react';
import PatientQueue from './PatientQueue';

// Types 27-30 are the RPM threshold/adherence alerts. They are worked from
// Urgent - RPM Threshold Alerts (APP-3772), so they are excluded here rather than shown twice.
const UrgentQueueCcm = () =>
    <PatientQueue
        showQueueCount
        patientNameColumn
        timeBilledColumn
        providerDetailColumn
        urgentColumn
        todoItemColumn
        showFilters
        showProgramTypeFilter
        showScheduleCallFilter
        statusColumn
        chartColumn
        lastWorkedByColumn
        page
        queue="urgentCcm"
        endpoint="Urgent?typesToExclude=1,8,16,18,19,27,28,29,30"
        label="Urgent"
    />;

export default UrgentQueueCcm;
